<template>
  <!-- D: 얼럿은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다. -->
  <!-- CYB_PC_LO_02_00 -->
  <div
    v-if="data.visible"
    class="alert"
    ref="alertRef"
    tabIndex="-1"
    data-alert
  >
    <template v-if="data.type == 'default'">
      <div class="dialog">
        <div class="dialog-content">
          <div class="text-wrap">
            <p v-html="data.message" class="text"></p>
          </div>
        </div>
        <div class="dialog-footer">
          <div class="c-btn-area type-full">
            <button
              type="button"
              class="c-button type-primary"
              data-alert-close
              @click="confirmAndClose"
            >
              <span>{{ data.confirmLabel }}</span>
            </button>
            <button
              type="button"
              class="c-button type-secondary"
              data-alert-close
              @click="cancelAndClose"
            >
              <span>{{ data.cancelLabel }}</span>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="data.type == 'set'">
      <div class="dialog type-large">
        <div class="dialog-content">
          <div class="text-wrap">
            <p class="text">
              {{ data.options.subZzmaktx }} 은<br />
              {{ data.options.zzmaktx }} 구성 제품입니다. <br />
              SET제품으로 추가하시겠습니까?
            </p>
          </div>
        </div>
        <div class="dialog-footer">
          <div class="c-btn-area type-full">
            <button
              type="button"
              class="c-button type-secondary"
              @click="confirmAndClose"
            >
              <span>개별제품추가</span>
            </button>
            <button
              type="button"
              class="c-button type-primary"
              @click="cancelAndClose"
            >
              <span>SET제품추가</span>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="data.type == 'kakao'">
      <div class="dialog type-large">
        <div class="dialog-content">
          <div class="text-wrap">
            <p class="text">
              <b>카카오톡으로 공유</b>
              <br />
              카카오톡으로 이동하시겠습니까?
            </p>
          </div>
        </div>
        <div class="dialog-footer">
          <div class="c-btn-area">
            <button
              type="button"
              class="c-button type-secondary"
              @click="cancelAndClose"
            >
              <span>취소</span>
            </button>
            <button
              type="button"
              class="c-button type-primary"
              @click="confirmAndClose"
            >
              <span>카톡으로 이동</span>
            </button>
          </div>
        </div>
      </div>
    </template>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>

<script setup name="ConfirmDialog">
import { reactive, onMounted, defineProps, watch, ref, nextTick } from "vue";
import { useConfirm } from "@/components/paintpro/composables/useConfirm";
const { confirmAction, cancelAction } = useConfirm();

const alertRef = ref(null);

const props = defineProps({
  uid: {
    // props로 고유 ID 받기
    type: String,
    required: false,
  },
});

const data = reactive({
  id: "",
  message: "",
  type: "",
  visible: false,
  options: {},
  confirmLabel: "-",
  cancelLabel: "-",
});

watch(
  () => data.visible,
  (newValue) => {
    if (newValue) {
      nextTick(() => {
        handleOpen();
      });
    }
  }
);

onMounted(() => {
  const { visible, message, type, options } = useConfirm(props.uid);
  data.id = props.uid;
  data.message = message;
  data.type = type;
  data.options = options;
  data.confirmLabel = options.confirmLabel || "확인";
  data.cancelLabel = options.cancelLabel || "취소";
  data.visible = visible;
  enablePageScroll(); // 초기 상태에서는 스크롤 활성화
});

function handleOpen() {
  alertRef.value.focus();
  setupFocusTrap(alertRef.value);
  disablePageScroll(); // 스크롤 방지
}

function setupFocusTrap(el) {
  // 팝업 내부의 포커스 가능한 요소들
  const focusableElements = el.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  if (focusableElements.length > 0) {
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    firstElement.focus();

    el.addEventListener("keydown", function (e) {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  } else {
    el.focus();
  }
}

// 페이지 스크롤 비활성화
const disablePageScroll = () => {
  document.body.style.overflow = "hidden"; // 스크롤 비활성화
};

// 페이지 스크롤 활성화
const enablePageScroll = () => {
  document.body.style.overflow = ""; // 스크롤 원상복구
};

// 확인 선택 후 팝업을 닫을 때 스크롤을 원래대로 돌려놓기
const confirmAndClose = () => {
  enablePageScroll(); // 팝업 닫을 때 스크롤 복원
  confirmAction();
};

// 취소 선택 후 팝업을 닫을 때 스크롤을 원래대로 돌려놓기
const cancelAndClose = () => {
  enablePageScroll(); // 팝업 닫을 때 스크롤 복원
  cancelAction();
};
</script>
